import { useMemo } from 'react';

import { FormProvider } from 'core/states';
import { IExternalPricesCustomization } from 'parts/types';

import { CustomizationRowFormFields } from './CustomizationRowFormFields';
import { customizationSchema } from './schema';

interface IProps {
  partNumber: string;
  manufacturerId: number;
  defaults?: Partial<IExternalPricesCustomization>;
  onApply: (values: IExternalPricesCustomization) => Promise<{ success: boolean }>;
  isApplying?: boolean;
}

export const CustomizationRow = ({
  partNumber,
  manufacturerId,
  defaults,
  onApply,
  isApplying,
}: IProps) => {
  const defaultValues = useMemo(
    () => ({
      shippingLocation: defaults?.shippingLocation ?? null,
      salesLocation: defaults?.salesLocation ?? null,
      shipmentType: defaults?.shipmentType ?? null,
      customerBillTo: defaults?.customerBillTo ?? null,
      project: defaults?.project ?? null,
    }),
    [defaults]
  );

  return (
    <FormProvider schema={customizationSchema()} defaultValues={defaultValues} resetDefaultValues>
      <CustomizationRowFormFields
        partNumber={partNumber}
        manufacturerId={manufacturerId}
        onApply={onApply}
        isApplying={isApplying}
      />
    </FormProvider>
  );
};
